import {Component, OnDestroy, OnInit} from '@angular/core';
import {DeviceService} from '@common-module/app-services/device.service';
import {UserRoleListService} from '../shared/service/user-role-list.service';
import {AppCustomizationService} from "@common-module/app-services/app-customization.service";
import { HeaderComponent } from './header/header.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-system',
    templateUrl: './system.component.html',
    imports: [HeaderComponent, RouterOutlet]
})
export class SystemComponent implements OnInit, OnDestroy {

  constructor(private appCustomizationService: AppCustomizationService,
              private deviceService: DeviceService,
              private userRoleListService: UserRoleListService) {
  }

  ngOnInit(): void {
    this.appCustomizationService.init();
  }

  ngOnDestroy(): void {
    this.userRoleListService.destroy();
    this.deviceService.destroy();
  }
}
